import {
  EPostSearchType,
  IPostSearch,
  IPostSearch_Comment,
} from '@/client/legacy-shared-modules/search/search-types';

const POST_HIT_ACTION_LABELS: Record<EPostSearchType, string> = {
  [EPostSearchType.BLOG]: 'posted an article',
  [EPostSearchType.POLL]: 'posted a poll',
  [EPostSearchType.POST]: 'posted',
  [EPostSearchType.COMMENT]: 'replied',
  [EPostSearchType.QUESTION]: 'asked a question',
  [EPostSearchType.ANSWER]: 'posted an answer',
};

function getCommentHitTitle(commentHit: IPostSearch_Comment): string {
  if (
    !commentHit.post ||
    typeof commentHit.post !== 'object' ||
    !('type' in commentHit.post)
  ) {
    return (
      (commentHit as unknown as { title?: string }).title ||
      commentHit.bodyPlainText ||
      'Comment'
    );
  }

  switch (commentHit.post.type) {
    case EPostSearchType.BLOG:
      return commentHit.post.blog.title;
    case EPostSearchType.POLL:
      return commentHit.post.poll.title;
    case EPostSearchType.POST:
      return commentHit.post.title;
    case EPostSearchType.ANSWER:
      return commentHit.post.answer.body;
    case EPostSearchType.QUESTION:
      return commentHit.post.question.title;
    default:
      return commentHit.bodyPlainText || 'Comment';
  }
}

export function getPostHitDisplay(hit: IPostSearch): {
  actionLabel: string;
  title: string;
  bodyAttribute: string;
} {
  const actionLabel = POST_HIT_ACTION_LABELS[hit.postType] ?? 'posted';

  const title =
    hit.postType === EPostSearchType.BLOG
      ? (hit as { blog?: { title?: string } }).blog?.title ?? 'Post'
      : hit.postType === EPostSearchType.POLL
      ? (hit as { poll?: { title?: string } }).poll?.title ?? 'Post'
      : hit.postType === EPostSearchType.QUESTION
      ? (hit as { question?: { title?: string } }).question?.title ?? 'Post'
      : hit.postType === EPostSearchType.POST
      ? (hit as { title?: string }).title ?? 'Post'
      : hit.postType === EPostSearchType.ANSWER
      ? (hit as { answer?: { question?: { title?: string } } }).answer?.question
          ?.title ?? 'Post'
      : getCommentHitTitle(hit as IPostSearch_Comment);

  const bodyAttribute =
    hit.postType === EPostSearchType.BLOG
      ? 'blog.content'
      : hit.postType === EPostSearchType.POLL
      ? 'poll.description'
      : hit.postType === EPostSearchType.QUESTION
      ? 'question.body'
      : hit.postType === EPostSearchType.ANSWER
      ? 'answer.body'
      : 'bodyPlainText';

  return { actionLabel, title, bodyAttribute };
}

export function getAiAskPostUrl(hit: IPostSearch): string {
  return hit.group?._id
    ? `/community/post/${hit.objectID}`
    : `/post/${hit.objectID}`;
}
